import React from "react";
import { Polygon, Tooltip } from "react-leaflet";

const UnstableZones = React.memo(({ unstableZones }) => {
    return unstableZones?.map((el, index) => (
        <Polygon
            key={index}
            color="#e5443c"
            fill
            fillColor="#e5443c"
            fillOpacity={0.2}
            weight={2}
            positions={el.coordinates.map((item) => [...item].reverse())}
        >
            <Tooltip className="map__tooltip" direction="top">
                Зона нестабильных координат
            </Tooltip>
        </Polygon>
    ));
});

const MemoizedUnstableZones = (props) => <UnstableZones {...props} />;

export default MemoizedUnstableZones;
